import type {PodRequestFn} from '../usePodRequest';

const OUTLOOK_EMAIL_SYNCS_LOOKUP_PATH =
  '/outlook_add_in/outlook_email_syncs/lookup';

export type LookupOutlookEmailSyncParams = {
  agencyId: number;
  inboxEmailAddress: string;
  internetMessageId?: string | null;
  microsoftMessageId?: string | null;
  fromAddress?: string | null;
  toAddresses?: readonly string[] | null;
  ccAddresses?: readonly string[] | null;
  subject?: string | null;
  sentAt?: string | null;
};

export type LookupOutlookEmailSyncJson = {
  existing_sync: boolean;
};

const appendArrayParams = (
  searchParams: URLSearchParams,
  key: string,
  values?: readonly string[] | null
) => {
  if (!values) {
    return;
  }
  for (const value of values) {
    searchParams.append(`${key}[]`, value.trim());
  }
};

export const buildLookupOutlookEmailSyncPath = (
  params: LookupOutlookEmailSyncParams
): string => {
  const searchParams = new URLSearchParams();

  const standardParams: Record<string, string | number | null | undefined> = {
    agency_id: params.agencyId,
    inbox_email_address: params.inboxEmailAddress,
    internet_message_id: params.internetMessageId,
    microsoft_message_id: params.microsoftMessageId,
    from_address: params.fromAddress,
    subject: params.subject,
    sent_at: params.sentAt,
  };
  Object.entries(standardParams).forEach(([key, value]) => {
    if (value) {
      searchParams.set(key, String(value));
    }
  });

  appendArrayParams(searchParams, 'to_addresses', params.toAddresses);
  appendArrayParams(searchParams, 'cc_addresses', params.ccAddresses);

  return `${OUTLOOK_EMAIL_SYNCS_LOOKUP_PATH}?${searchParams.toString()}`;
};

export const lookupOutlookEmailSync = async (
  request: PodRequestFn,
  params: LookupOutlookEmailSyncParams,
  init?: RequestInit
): Promise<LookupOutlookEmailSyncJson> => {
  const response = await request(buildLookupOutlookEmailSyncPath(params), init);
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`);
  }
  return JSON.parse(text) as LookupOutlookEmailSyncJson;
};
